import Vue from 'vue'
import VueRouter from 'vue-router'
import VueMeta from 'vue-meta'
import routes from './routes'
import i18n from '@/lib/vue-i18n'

Vue.use(VueRouter);
Vue.use(VueMeta, {
    keyName: 'page',
});

const SUPPORTED_LANGUAGES = ['vi', 'en'];
const SDK_LANG_STORAGE_KEY = 'lang';

const syncLocale = (lang) => {
    if (!SUPPORTED_LANGUAGES.includes(lang)) {
        return;
    }

    i18n.locale = lang;
    window.localStorage.setItem(SDK_LANG_STORAGE_KEY, lang);

    if (window.axios && window.axios.defaults && window.axios.defaults.headers) {
        if (window.axios.defaults.headers.common) {
            window.axios.defaults.headers.common['accept-language'] = lang;
        }

        window.axios.defaults.headers['accept-language'] = lang;
    }
};

const getStoredLanguage = () => {
    const lang = window.localStorage.getItem(SDK_LANG_STORAGE_KEY);

    return SUPPORTED_LANGUAGES.includes(lang) ? lang : SUPPORTED_LANGUAGES[0];
};

const getQueryWithoutLanguage = (query) => {
    const nextQuery = { ...query };

    delete nextQuery.lang;

    return nextQuery;
};

const router = new VueRouter({
    routes,
    mode: 'history',
    scrollBehavior(to, from, savedPosition) {
        if (savedPosition) {
            return savedPosition
        } else {
            return {
                x: 0,
                y: 0
            }
        }
    },
});

router.beforeEach((to, from, next) => {
    const routeLang = to.query.lang;

    if (SUPPORTED_LANGUAGES.includes(routeLang)) {
        syncLocale(routeLang);
        next({
            path: to.path,
            query: getQueryWithoutLanguage(to.query),
            hash: to.hash,
            replace: true,
        });
        return;
    }

    syncLocale(getStoredLanguage());
    // if (to.meta.authRequired) {
    //     if (!(jwt.isAuthenticated() || Cookie.get('_auth'))) {
    //         store.dispatch("auth/setReturnUrl", to.query.returnUrl);
    //         router.push({ name: 'login', query: { to: to.path } })
    //     }
    // } else {
    //     if ((jwt.isAuthenticated() && Cookie.get('_auth'))) {
    //         router.push({ path: '/user' })
    //     }
    // }
    next()
})

export default router
